

import { useEffect, useState } from "react";
import API from "../services/api";
import { FaUserTimes } from "react-icons/fa";


import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Legend
} from "recharts";

import {
    FaUserGraduate,
    FaUsers,
    FaMoneyBillWave,
    FaClipboardCheck,
    FaBell,
    FaBus,
    FaPlus
} from "react-icons/fa";

export default function Dashboard() {

    const [showEventModal, setShowEventModal] = useState(false);

    const [eventForm, setEventForm] = useState({
        title: "",
        description: "",
        event_date: "",
        start_time: "",
        end_time: ""
    });

    const [data, setData] = useState({
        totalStudents: 0,
        totalStaff: 0,
        totalRevenue: 0,
        totalExpenses: 0,
        pendingFees: 0
    });

    const [academicYear, setAcademicYear] = useState("");
    

    const role = localStorage.getItem("role");

    console.log("Current Role =", role);

    useEffect(() => {
        fetchSummary();
        fetchUpcomingEvents();
        fetchActiveAcademicYear();
    }, []);

    const fetchSummary = async () => {

        const res = await API.get("/dashboard/summary");

        setData(res.data);

        setRecentActivities(res.data.recentActivities || []);

    };


    const fetchUpcomingEvents = async () => {

        try {

            const res = await API.get("/events/upcoming");

            setUpcomingEvents(res.data);

        } catch (err) {

            console.error(err);

        }

    };

    const fetchActiveAcademicYear = async () => {

        try {

            const res = await API.get(
                "/settings/active-academic-year"
            );

            setAcademicYear(res.data.academic_year);

        }

        catch (err) {

            console.log(err);

        }

    };

    const handleCreateEvent = async () => {

        try {

            await API.post("/events", eventForm);

            alert("Event created successfully.");

            setShowEventModal(false);

            setEventForm({
                title: "",
                description: "",
                event_date: "",
                start_time: "",
                end_time: ""
            });

            fetchUpcomingEvents();

        } catch (err) {

            alert("Unable to create event.");

        }

    };

    const financialData = [
        {
            name: "Revenue",
            amount: Number(data.totalRevenue)
        },
        {
            name: "Expenses",
            amount: Number(data.totalExpenses)
        },
        {
            name: "Pending",
            amount: Number(data.pendingFees)
        }
    ];

   

    const attendanceData = [
        {
            name: "Present",
            value: Number(data.presentStudents || 0)
        },
        {
            name: "Absent",
            value: Number(data.absentStudents || 0)
        }
    ];

    const COLORS = ["#2563eb", "#ef4444"];


    const [recentActivities, setRecentActivities] = useState([]);

    const [upcomingEvents, setUpcomingEvents] = useState([]);
    

    return (
        <div className="p-3 sm:p-4 lg:p-6 bg-gray-100 min-h-screen">

            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 sm:mb-8">

                <div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
                        Corporate ERP Dashboard
                    </h1>

                    <p className="text-gray-500 mt-1">
                        School operations overview
                    </p>
                </div>

                <div className="bg-white shadow px-4 sm:px-5 py-3 rounded-xl w-full sm:w-auto">
                    <p className="text-sm text-gray-500">
                        Academic Year
                    </p>

                    <h2 className="font-bold text-lg">
                        {academicYear}
                    </h2>
                </div>

            </div>

            {/* KPI Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3 sm:gap-5 mb-6 sm:mb-8">

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-blue-600">
                    <div className="flex justify-between items-center">

                        <div>
                            <p className="text-gray-500">
                                Students
                            </p>

                            <h2 className="text-3xl font-bold mt-2">
                                {data.totalStudents}
                            </h2>
                        </div>

                        <FaUserGraduate className="text-4xl text-blue-600" />

                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-orange-500">
                    <div className="flex justify-between items-center">

                        <div>
                            <p className="text-gray-500">
                                Staff
                            </p>

                            <h2 className="text-3xl font-bold mt-2">
                                {data.totalStaff}
                            </h2>
                        </div>

                        <FaUsers className="text-4xl text-orange-500" />

                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-green-600">
                    <div className="flex justify-between items-center">

                        <div>
                            <p className="text-gray-500">
                                Revenue
                            </p>

                            <h2 className="text-2xl font-bold mt-2">
                                ₹{data.totalRevenue}
                            </h2>
                        </div>

                        <FaMoneyBillWave className="text-4xl text-green-600" />

                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-red-500">
                    <div className="flex justify-between items-center">

                        <div>
                            <p className="text-gray-500">
                                Expenses
                            </p>

                            <h2 className="text-2xl font-bold mt-2">
                                ₹{data.totalExpenses}
                            </h2>
                        </div>

                        <FaClipboardCheck className="text-4xl text-red-500" />

                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-purple-600">
                    <div className="flex justify-between items-center">

                        <div>
                            <p className="text-gray-500">
                                Pending Fees
                            </p>

                            <h2 className="text-2xl font-bold mt-2">
                                ₹{data.pendingFees}
                            </h2>
                        </div>

                        <FaBell className="text-4xl text-purple-600" />

                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-cyan-600">

                    <p className="text-gray-500">
                        Monthly Collection
                    </p>

                    <h2 className="text-2xl font-bold mt-2">
                        ₹{data.monthlyCollection}
                    </h2>

                </div>



                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-pink-600">

                    <p className="text-gray-500">
                        Today's Collection
                    </p>

                    <h2 className="text-2xl font-bold mt-2">
                        ₹{data.todayCollection}
                    </h2>

                </div>



                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-yellow-500">

                    <p className="text-gray-500">
                        Pending Students
                    </p>

                    <h2 className="text-2xl font-bold mt-2">
                        {data.totalPendingStudents}
                    </h2>

                </div>


                {/* Present Today */}

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-green-500">

                    <div className="flex justify-between items-center">

                        <div>

                            <p className="text-gray-500">
                                Present Today
                            </p>

                            <h2 className="text-2xl font-bold mt-2">
                                {data.presentStudents || 0}
                            </h2>

                        </div>

                        <FaClipboardCheck className="text-4xl text-green-500" />

                    </div>

                </div>



                {/* Absent Today */}

                <div className="bg-white rounded-2xl shadow p-5 border-l-4 border-red-500">

                    <div className="flex justify-between items-center">

                        <div>

                            <p className="text-gray-500">
                                Absent Today
                            </p>

                            <h2 className="text-2xl font-bold mt-2">
                                {data.absentStudents || 0}
                            </h2>

                        </div>

                        <FaUserTimes className="text-4xl text-red-500" />

                    </div>

                </div>



                {/*<div className="bg-white rounded-2xl shadow p-5 border-l-4 border-yellow-500">*/}

                {/*    <p className="text-gray-500">*/}
                {/*        Pending Students*/}
                {/*    </p>*/}

                {/*    <h2 className="text-2xl font-bold mt-2">*/}
                {/*        {data.totalPendingStudents}*/}
                {/*    </h2>*/}

                {/*</div>*/}



            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">

                {/* Financial Chart */}
                <div className="bg-white rounded-2xl shadow p-6">

                    <div className="flex justify-between items-center mb-5">

                        <h2 className="text-xl font-bold text-gray-700">
                            Financial Overview
                        </h2>

                        <FaMoneyBillWave className="text-green-600 text-2xl" />

                    </div>

                    <ResponsiveContainer width="100%" height={320}>
                        <BarChart data={financialData}>
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />

                            <Bar
                                dataKey="amount"
                                fill="#2563eb"
                                radius={[10, 10, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>

                </div>

                {/* Attendance Chart */}
                <div className="bg-white rounded-2xl shadow p-6">

                    <div className="flex justify-between items-center mb-5">

                        <h2 className="text-xl font-bold text-gray-700">
                            Attendance Overview
                        </h2>

                        <FaClipboardCheck className="text-purple-600 text-2xl" />

                    </div>

                    <ResponsiveContainer width="100%" height={320}>
                        <PieChart>

                            <Pie
                                data={attendanceData}
                                dataKey="value"
                                cx="50%"
                                cy="50%"
                                outerRadius={100}
                                label
                            >

                                {attendanceData.map((entry, index) => (
                                    <Cell
                                        key={index}
                                        fill={COLORS[index % COLORS.length]}
                                    />
                                ))}

                            </Pie>

                            <Tooltip />
                            <Legend />

                        </PieChart>
                    </ResponsiveContainer>

                </div>

            </div>

            {/* Quick Actions */}
            <div className="bg-white rounded-2xl shadow p-6 mb-8">

                <div className="flex justify-between items-center mb-6">

                    <h2 className="text-2xl font-bold text-gray-700">
                        Quick Actions
                    </h2>
 

                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                    <a
                        href="/students"
                        className="bg-blue-700 hover:bg-blue-800 transition text-white rounded-xl p-5 text-center"
                    >
                        <FaUserGraduate className="mx-auto text-3xl mb-3" />

                        <p className="font-semibold">
                            Add Student
                        </p>
                    </a>

                    <a
                        href="/fees"
                        className="bg-green-700 hover:bg-green-800 transition text-white rounded-xl p-5 text-center"
                    >
                        <FaMoneyBillWave className="mx-auto text-3xl mb-3" />

                        <p className="font-semibold">
                            Collect Fees
                        </p>
                    </a>

                    <a
                        href="/attendance"
                        className="bg-purple-700 hover:bg-purple-800 transition text-white rounded-xl p-5 text-center"
                    >
                        <FaClipboardCheck className="mx-auto text-3xl mb-3" />

                        <p className="font-semibold">
                            Attendance
                        </p>
                    </a>

                    {/*<a*/}
                    {/*    href="/transport"*/}
                    {/*    className="bg-orange-500 hover:bg-orange-600 transition text-white rounded-xl p-5 text-center"*/}
                    {/*>*/}
                    {/*    <FaBus className="mx-auto text-3xl mb-3" />*/}

                    {/*    <p className="font-semibold">*/}
                    {/*        Transport*/}
                    {/*    </p>*/}
                    {/*</a>*/}

                </div>

            </div>

            {/* Bottom Panels */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

                {/* Recent Activities */}
                <div className="bg-white rounded-2xl shadow p-6">

                    <div className="flex justify-between items-center mb-5">

                        <div className="flex items-center gap-3">

                            <FaBell className="text-orange-500 text-2xl" />

                            <h2 className="text-2xl font-bold text-gray-700">
                                Recent Activities
                            </h2>

                        </div>

                        {/*<button*/}
                        {/*    onClick={() => setShowEventModal(true)}*/}
                        {/*    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"*/}
                        {/*>*/}
                        {/*    + Add Event*/}
                        {/*</button>*/}

                    </div>

                    <div className="space-y-4">

                        {recentActivities.length === 0 ? (

                            <div className="text-gray-500 text-center py-4">
                                No recent activities
                            </div>

                        ) : (

                            recentActivities.map((item, index) => (

                                <div
                                    key={index}
                                    className="border-b pb-3"
                                >

                                    <div className="font-medium text-gray-800">
                                        {item.activity}
                                    </div>

                                    <div className="text-sm text-gray-500">

                                        {item.module}
                                        {" • "}
                                        {item.username}
                                        {" • "}
                                        {new Date(item.created_at).toLocaleString()}

                                    </div>

                                </div>

                            ))

                        )} 

                    </div>

                </div>

                {/* Upcoming Events */}
                <div className="bg-white rounded-2xl shadow p-6">

                    <div className="flex items-center gap-3 mb-5">

                        <FaBell className="text-orange-500 text-2xl" />

                        <h2 className="text-2xl font-bold text-gray-700">
                            Upcoming Events
                        </h2>

                      <div>
                        <button
                            onClick={() => setShowEventModal(true)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
                        >
                            + Add Event
                        </button>
                    </div>
                    </div>

                    <div className="space-y-4">

                        {upcomingEvents.map((event) => (

                            <div
                                key={event.id}
                                className="border-b pb-3"
                            >

                                <div className="font-semibold text-gray-800">
                                    {event.title}
                                </div>

                                <div className="text-sm text-gray-500">
                                    {new Date(event.event_date).toLocaleDateString()}
                                </div>

                                {event.start_time && (

                                    <div className="text-sm text-blue-600">
                                        {event.start_time}
                                    </div>

                                )}

                            </div>

                        ))}
                         

                    </div>

                </div>

            </div>


            {
                showEventModal && (

                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

                        <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6">

                            <h2 className="text-2xl font-bold mb-6">
                                Add Event
                            </h2>

                            <input
                                placeholder="Event Title"
                                className="border w-full p-3 rounded mb-3"
                                value={eventForm.title}
                                onChange={(e) => setEventForm({ ...eventForm, title: e.target.value })}
                            />

                            <textarea
                                placeholder="Description"
                                className="border w-full p-3 rounded mb-3"
                                rows="3"
                                value={eventForm.description}
                                onChange={(e) => setEventForm({ ...eventForm, description: e.target.value })}
                            />

                            <input
                                type="date"
                                className="border w-full p-3 rounded mb-3"
                                value={eventForm.event_date}
                                onChange={(e) => setEventForm({ ...eventForm, event_date: e.target.value })}
                            />

                            <input
                                type="time"
                                className="border w-full p-3 rounded mb-3"
                                value={eventForm.start_time}
                                onChange={(e) => setEventForm({ ...eventForm, start_time: e.target.value })}
                            />

                            <div className="flex justify-end gap-3">

                                <button
                                    onClick={() => setShowEventModal(false)}
                                    className="px-5 py-2 bg-gray-300 rounded"
                                >
                                    Cancel
                                </button>

                                <button
                                    onClick={handleCreateEvent}
                                    className="px-5 py-2 bg-blue-600 text-white rounded"
                                >
                                    Save Event
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>
    );
}